import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Injector,
  InputSignal,
  ModelSignal,
  OutputEmitterRef,
  TemplateRef,
  ViewChild,
  afterNextRender,
  input,
  model,
  output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { IconDirective } from '@core/shared/util';

import { FilterSearchFieldComponent } from '../../../filter-search-field/filter-search-field.component';

@Component({
  selector: 'mp-filter-group',
  templateUrl: './filter-group.component.html',
  styleUrl: './filter-group.component.scss',
  host: {
    '[class.mp-filter-group--expanded]': 'isExpanded()',
    '[class.mp-filter-group--scrollable]': 'scrollable()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, IconDirective, MatIconModule, MatButtonModule, FilterSearchFieldComponent],
})
export class FilterGroupComponent {
  readonly filterName: InputSignal<string> = input<string>('');
  readonly filterNameTemplate: InputSignal<TemplateRef<unknown> | undefined> = input<TemplateRef<unknown>>();

  readonly icon: InputSignal<string | undefined> = input<string>();

  readonly searchable: InputSignal<boolean> = input<boolean>(false);
  readonly searchFieldPlaceholder: InputSignal<string> = input<string>('Durchsuchen');
  readonly customSearchTemplate: InputSignal<TemplateRef<unknown> | undefined> = input<TemplateRef<unknown>>();

  readonly isExpanded: ModelSignal<boolean> = model<boolean>(false);
  readonly isSearchExpanded: ModelSignal<boolean> = model<boolean>(false);

  readonly scrollable: InputSignal<boolean> = input<boolean>(true);

  readonly searchTermChange: OutputEmitterRef<string> = output<string>();

  @ViewChild('searchField')
  searchField?: FilterSearchFieldComponent;

  constructor(private readonly injector: Injector) {}

  toggleExpanded(): void {
    this.isExpanded.set(!this.isExpanded());
  }

  toggleSearchExpanded(): void {
    this.isSearchExpanded.set(!this.isSearchExpanded());

    if (this.isSearchExpanded()) {
      afterNextRender({ read: () => this.searchField?.focus() }, { injector: this.injector });
    } else {
      this.executeSearch('');
    }
  }

  executeSearch(searchTerm: string): void {
    this.searchTermChange.emit(searchTerm);
  }
}
